import {
  Component,
  OnInit,
  QueryList,
  ViewChildren
} from '@angular/core';

import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { UIRouter }    from '@uirouter/core';

import { CompanyService }   from '../companies/company.service';
import { PluralizePipe }    from '../shared/pipes/pluralize.pipe';
import { RemindersService } from '../reminders/reminders.service';
import { SessionService }   from '../sessions/session.service';
import { SidebarService }   from './sidebar.service';
import { StockTakeService } from '../stock-take/stock-take.service';

import amsRewardsIcon   from 'icons/ams-rewards.svg';
import bntIcon          from 'icons/bnt.svg';
import mitchell1Icon    from 'icons/mitchell1.svg';
import myobIcon         from 'icons/myob.svg';
import napaIcon         from 'icons/napa.svg';
import podiumIcon       from 'icons/podium.svg';
import tiremetrixIcon   from 'icons/tiremetrix.svg';
import vvGarageIcon     from 'icons/vv-garage.svg';
import workshopDataIcon from 'icons/workshop-data.circle.svg';

@Component({
  selector   : 'wor-sidebar',
  styles: [ require('./sidebar.component.scss') ],
  template: require('./sidebar.component.html')
})
export class SidebarComponent implements OnInit {
  public isSubmenuShowing = false;
  public amsRewardsIcon   = amsRewardsIcon;
  public bntIcon          = bntIcon;
  public mitchell1Icon    = mitchell1Icon;
  public myobIcon         = myobIcon;
  public napaIcon         = napaIcon;
  public podiumIcon       = podiumIcon;
  public tiremetrixIcon   = tiremetrixIcon;
  public vvGarageIcon     = vvGarageIcon;
  public workshopDataIcon = workshopDataIcon;

  @ViewChildren(NgbCollapse) menus: QueryList<NgbCollapse>;

  constructor (
    public companyService   : CompanyService,
    public pluralizePipe    : PluralizePipe,
    private remindersService: RemindersService,
    private router          : UIRouter,
    public sessionService   : SessionService,
    private sidebarService  : SidebarService,
    private stockTakeService: StockTakeService
  ) {}

  ngOnInit () : void {
    this.sidebarService.reset$.subscribe(() => this.closeSubmenus());
  }

  closeSubmenus ( submenu : NgbCollapse | Array<NgbCollapse> = this.menus.toArray(), menu ?: NgbCollapse ) : void {
    if ( submenu instanceof Array ) {
      submenu.forEach(item =>   {
        if ( !item.collapsed && item !== menu ) {
          item.toggle(false);
        }
      });
    }
    else if (!submenu.collapsed) {
      submenu.toggle(false);
    }

    this.isSubmenuShowing = false;
  }

  isStockTakeAvailable () : boolean {
    return this.companyService.hasWorkshop()
      && this.companyService.isSubscriptionPlan('silver', false)
      && !this.isStockTakeRestricted();
  }

  isStockTakeRestricted () : boolean {
    return this.companyService.isBrand('nrma')
      && this.companyService.hasSecurityRights('create_stocktake');
  }

  navigate ( state = 'app', evt : Event ) : void {
    this.router.stateService.go(state);

    evt.preventDefault();
    evt.stopPropagation();
  }

  sendReminders () : void {
    this.remindersService.send();
  }

  stockTakeQuickAdd ( evt : Event ) : void {
    this.stockTakeService.quickAdd();

    evt.preventDefault();
    evt.stopPropagation();
  }

  toggleBottomMenu ( menu : NgbCollapse ) : void {
    this.isSubmenuShowing = !this.isSubmenuShowing;

    menu.toggle();
  }

  toggleSubmenu ( menu : NgbCollapse, menusToClose : Array<NgbCollapse> = [] ) : void {
    if (menusToClose.length) {
      menusToClose.forEach(menu => menu.collapsed ? null : menu.toggle());
    }
    else {
      this.closeSubmenus(undefined, menu);
    }

    menu.toggle();
  }
}
